import { getPositionBriqueRapport } from '@/scripts/global.js';
import { trouverElementFrere } from '@/scripts/navigationRapport.js'
import { 
    apiCollerBriquesRapport,
	apiModifierTextesBriquesRapport,
    apiModifierValeurs } from '@/services/ServiceModele.js';

const DELIMITEUR_TXT_LIGNES = '\n';
const DELIMITEUR_TXT_ELEMENTS = '\n\n';
const DELIMITEUR_TXT_VALEURS = ';';

const TYPE_TEXTE = 'text/plain';
const TYPE_HTML = 'text/html';
const TYPE_JSON = 'web application/json';

export function getTextesBriquesACopier(elements) {
	return concatenerTextes(elements.map(elt => getTextesBrique(elt)), DELIMITEUR_TXT_ELEMENTS);
}

function concatenerTextes(textesSimpleEtHtml, delimiteurTexteSimple, prefixeHtml, suffixeHtml) {
	return {
		texteSimple: textesSimpleEtHtml.map(texteSimpleEtHtml => texteSimpleEtHtml.texteSimple).join(delimiteurTexteSimple),
		texteHtml: (prefixeHtml ? prefixeHtml : '') + textesSimpleEtHtml.map(texteSimpleEtHtml => texteSimpleEtHtml.texteHtml).join('') + (suffixeHtml ? suffixeHtml : '')
	};
}

function getTextesBrique(element) {
	let style = '';
	if (element.style) {
		style = (element.style.borderWidth?.length > 0 ? 'border-style: solid; ' : '') + Object.keys(element.style).filter(propriete => propriete !== 'type').map(propriete => `${propriete.replaceAll(/([A-Z])/g, '-$1').toLowerCase()}: ${element.style[propriete]}; `).join('');
	}
	switch(element.type) {
		case 'SECTION':
			const textesSimpleEtHtml = [getTextesBrique(element.titre)];
			element.elements.map(zone => getTextesBrique(zone)).forEach(textesBrique => textesSimpleEtHtml.push(textesBrique));
			element.sousSections.map(sousSection => getTextesBrique(sousSection)).forEach(textesBrique => textesSimpleEtHtml.push(textesBrique));
			return concatenerTextes(textesSimpleEtHtml, DELIMITEUR_TXT_ELEMENTS, `<div${style ? " style='" + style + "'" : ""}>`, '</div><br>');
		case 'ZONE':
			return concatenerTextes(element.elements.map(elt => getTextesBrique(elt)), DELIMITEUR_TXT_ELEMENTS, `<div${style ? " style='" + style + "'" : ""}>`, '</div><br>');
		case 'TABLEAU': {
			const nbLignes = Math.max(...element.cellules.map(c => c.ligne));
			const nbColonnes = Math.max(...element.cellules.map(c => c.colonne));
			const textesLignes = [];
			for (let ligne = 1; ligne <= nbLignes; ligne++) {
				textesLignes.push(getTextesLigneTableau(element, ligne, nbColonnes));
			}
			return concatenerTextes(textesLignes, DELIMITEUR_TXT_LIGNES, `<table${style ? " style='" + style + "'" : ""}>`, '</table><br>');
		}
		case 'GRAPHIQUE': {
			const textesLignes = [];
			textesLignes.push(getTextesBrique(element.axePrincipal));
			for (const serie of element.series) {
				textesLignes.push(getTextesBrique(serie));
			}
			return concatenerTextes(textesLignes, DELIMITEUR_TXT_LIGNES, `<table${style ? " style='" + style + "'" : ""}>`, '</table><br>');
		}
		case 'TEXTE': {
			const texte = element.briquesTexte.map(briqueTexte => briqueTexte.texte).join('');
			return {texteSimple: texte, texteHtml: `<div${style ? " style='" + style + "'" : ""}>${texte}</div><br>`};
		}
		case 'SELECTEUR': {
			const texte = element.valeurs[element.indiceValSelect];
			return {texteSimple: texte, texteHtml: `<div${style ? " style='" + style + "'" : ""}>${texte}</div><br>`};

		}
		case 'EnteteObjetsBloc':
		case 'EnteteObjet':
		case 'EnteteExpression':
		case 'EnteteVariable':
		case 'EnteteRegroupement':
		case 'ValeurExpression':
		case 'ValeurAgregatGroupe':
		case 'ValeurAgregatTotal': {
			style += getStyleCelluleTableau();
			let spans = getSpansCelluleTableau(element);
			return {texteSimple: element.valeur.valBrute, texteHtml: `<td${style ? " style='" + style + "'" : ""} ${spans.rowspan} ${spans.colspan}>${element.valeur.valFormat}</td>`};
		}
		case 'EnteteValeurVariable':
		case 'EnteteValeurGroupe': {
			style += getStyleCelluleTableau();
			let spans = getSpansCelluleTableau(element);
			return {texteSimple: element.valeur.valInfo, texteHtml: `<td${style ? " style='" + style + "'" : ""} ${spans.rowspan} ${spans.colspan}>${element.valeur.valFormat}</td>`};
		}
		case 'EnteteAgregatGroupe':
		case 'EnteteAgregatTotal':
		case 'FiltreTableau': {
			style += getStyleCelluleTableau();
			let spans = getSpansCelluleTableau(element);
			return {texteSimple: element.valeur.valFormat, texteHtml: `<td${style ? " style='" + style + "'" : ""} ${spans.rowspan} ${spans.colspan}>${element.valeur.valFormat}</td>`};
		}
		case 'AxePrincipal':
		case 'SerieGraphique': {
			style += getStyleCelluleGraphique();
			const textesLigne = [];
			textesLigne.push({texteSimple: element.valeur.valBrute, texteHtml: `<td${style ? " style='" + style + "'" : ""}>${element.valeur.valFormat}</td>`});
			for (const valeur of element.valeurs) {
				textesLigne.push(getTextesBrique(valeur));
			}
			return concatenerTextes(textesLigne, DELIMITEUR_TXT_VALEURS, `<tr${style ? " style='" + style + "'" : ""}>`, '</tr>');
		}
		case 'ValeurAxe':
			style += getStyleCelluleGraphique();
			return {texteSimple: element.valeur.valInfo, texteHtml: `<td${style ? " style='" + style + "'" : ""}>${element.valeur.valFormat}</td>`};
		case 'ValeurSerie':
			style += getStyleCelluleGraphique();
			return {texteSimple: element.valeur.valBrute, texteHtml: `<td${style ? " style='" + style + "'" : ""}>${element.valeur.valFormat}</td>`};
	}
}

function getTextesLigneTableau(tableau, ligne, nbColonnes) {
	const textesValeurs = [];
	for (let colonne = 1; colonne <= nbColonnes; colonne++) {
		let cellule = tableau.cellules.find(c => c.ligne === ligne && c.colonne === colonne);
		if (cellule) {
			textesValeurs.push(getTextesBrique(cellule));
		} else {
			textesValeurs.push({texteSimple: '', texteHtml: ''});
		}
	}
	return concatenerTextes(textesValeurs, DELIMITEUR_TXT_VALEURS, '<tr>', '</tr>');
}

export async function copierDansPressePapier(texteSimple, texteHtml, texteJson) {
	const contenuPressePapier = {
		[TYPE_TEXTE]: new Blob(
			[texteSimple],
			{type: TYPE_TEXTE}),
		[TYPE_HTML]: new Blob(
			[texteHtml],
			{type: TYPE_HTML}),
			[TYPE_JSON]: new Blob(
			[texteJson],
			{type: TYPE_JSON})
	};
	return await navigator.clipboard.write([new ClipboardItem(contenuPressePapier)]);
}

export async function getAppelApiColler(element, rapport) {
	const contenuPressePapier = await navigator.clipboard.read();
	const elementPressePapier = contenuPressePapier[0];
	if (elementPressePapier.types.includes(TYPE_JSON)) {
		const blob = await elementPressePapier.getType(TYPE_JSON);
		const jsonBriques = await blob.text();
		const infoBrique = {
			positionBrique: getPositionBriqueRapport(element, element.elementParent),
			texte: jsonBriques
		};
		return {
			api: apiCollerBriquesRapport,
			argument: infoBrique
		};
	} else if (elementPressePapier.types.includes('text/plain')) {
		const typeCollage = (element.valeur?.coord ? 'valeurs' : 'textes');
		const argument = [];
		var elementEtParent = {element: element, parent: element.elementParent};
		const blob = await elementPressePapier.getType('text/plain');
		const texte = await blob.text();
		const lignes = texte.replace('\r', '').split('\n');
		var elementEtParentDebutLigne = elementEtParent;
		var premiereLigne = true;
		for (const ligne of lignes) {
			if (premiereLigne) {
				premiereLigne = false;
			} else {
				elementEtParentDebutLigne = trouverElementFrere(elementEtParentDebutLigne, 'bas', 1, rapport);
				if (!elementEtParentDebutLigne) {
					break;
				}
				elementEtParent = elementEtParentDebutLigne;
			}
			if (ligne.length === 0) {
				continue;
			}
			const valeurs = ligne.split('\t');
			var premiereValeur = true;
			for (const valeur of valeurs) {
				if (premiereValeur) {
					premiereValeur = false;
				} else {
					elementEtParent = trouverElementFrere(elementEtParent, 'droite', 1, rapport);
					if (!elementEtParent) {
						break;
					}
				}
				var modification = null;
				if (typeCollage === 'valeurs') {
					modification = {
						coord: elementEtParent.element.valeur?.coord,
						valeur: valeur
					};
				} else if (typeCollage === 'textes') {
					modification = {
						positionBrique: getPositionBriqueRapport(elementEtParent.element, elementEtParent.parent),
						texte: valeur
					};
				}
				argument.push(modification);
			}
		}
		if (argument.length > 0) {
			var api = null;
			if (typeCollage === 'valeurs') {
				api = apiModifierValeurs;
			} else if (typeCollage === 'textes') {
				api = apiModifierTextesBriquesRapport;
			}
			return {
				api: api,
				argument: argument
			};
		}
	}
}

function getStyleCelluleTableau() {
	let style = '';
	style += 'padding: 3px 16px; ';
	style += 'text-align: center; ';
	style += 'vertical-align: middle; ';
	style += 'min-width: 70px; ';
	return style;
}

function getStyleCelluleGraphique() {
	let style = '';
	style += 'padding: 3px 16px; ';
	style += 'text-align: center; ';
	style += 'vertical-align: middle; ';
	style += 'min-width: 70px; ';
	style += 'border-style: solid;';
	style += 'border-width: 1px;';
	style += 'border-color: rgb(218, 220, 224);';
	return style;
}

function getSpansCelluleTableau(element) {
	return {
		colspan: (element.largeur > 1 ? `colspan="${element.largeur}"` : ''),
		rowspan: (element.hauteur > 1 ? `rowspan="${element.hauteur}"` : '')
	};
}